import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { Box } from '@mui/material';
import {
  GridColDef,
  GridRenderCellParams,
  GridTreeNodeWithRender,
} from '@mui/x-data-grid';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { EditIcon, TrashIcon } from '../components/Icons';
import { ERole } from '../enums/user/ERole';
import { ETheme } from '../enums/user/ETheme';
import { IClient } from '../interfaces/clients/IClient';
import { darkTheme, lightTheme } from '../mui/theme';

export const useClientColumns = (
  setSelectedClient: (client: IClient) => void,
  setShowDeleteModal: (show: boolean) => void,
  setIsAddModalOpened: (show: boolean) => void,
  hideActionColumn = false,
): GridColDef[] => {
  const { t } = useTranslation();
  const { userData } = useSelector((state: RootState) => state.auth);
  const isNormalUser = userData?.role === ERole.USER;
  return [
    { field: 'id', headerName: t('general.id'), width: 50 },
    {
      field: 'name',
      headerName: t('client.name'),
      flex: 1,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {params.value}
        </div>
      ),
    },

    {
      field: 'actions',
      headerName: t('general.action'),
      width: 150,
      sortable: false,
      headerClassName: hideActionColumn ? 'hideColumn' : '',
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => (
        <Box
          sx={{
            display: hideActionColumn ? 'none' : 'flex',
            alignItems: 'center',
            height: '100%',
          }}
        >
          {/* Edit or View Icon */}
          <span
            style={{ cursor: 'pointer', display: 'flex' }}
            onClick={() => {
              setIsAddModalOpened(true);
              setSelectedClient(params?.row);
            }}
          >
            {!isNormalUser ? (
              <EditIcon
                fill={
                  userData?.theme === ETheme.LIGHT
                    ? lightTheme.palette.text.primary
                    : darkTheme.palette.text.primary
                }
              />
            ) : (
              <RemoveRedEyeOutlinedIcon
                fill={
                  userData?.theme === ETheme.LIGHT
                    ? lightTheme.palette.text.primary
                    : darkTheme.palette.text.primary
                }
              />
            )}
          </span>

          {/* Delete Icon */}
          {!isNormalUser && (
            <span
              style={{ cursor: 'pointer' }}
              className={'ms-3 d-flex'}
              onClick={() => {
                setSelectedClient(params.row);
                setShowDeleteModal(true);
              }}
            >
              <TrashIcon
                fill={
                  userData?.theme === ETheme.LIGHT
                    ? lightTheme.palette.text.primary
                    : darkTheme.palette.text.primary
                }
              />
            </span>
          )}
        </Box>
      ),
    },
  ];
};
